.c-voucher-form {
  min-height: 65px;
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/Invite/components/VoucherForm.less